import React from 'react';

const AnniversaryTextSection = () => {
  return (
    <section className="relative py-20 overflow-hidden">
      {/* Background with yellow gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-black via-yellow-900/30 to-black"></div>
      
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        {/* Section removed - content moved to HeroSection */}
      </div>
    </section>
  );
};

export default AnniversaryTextSection;
